import ComplaintList from './ComplaintList'

export default ComplaintList
